<div
  data-event="purchase"
  data-cart="{JSON.stringify([
    {
      id: '123 (article no)',
      name: 'productname',
      brand: 'productbrand',
      category: 'top level category',
      price: '123,56',
      quantity: '1',
    },
    {
      id: '456 (article no)',
      name: 'another productname',
      brand: 'another productbrand',
      category: 'top level category',
      price: '456,78',
      quantity: '2',
    },
  ])}"
  data-order-id="123ABC"
  data-revenue="6000,78"
  data-tax="1000,63"
  data-shipping="250,15"
>
  <h1>Checkout complete</h1>
  <p>Add data tags somewhere on page</p>
  <p>data-cart should contain a json string with the cart contents.</p>
  <ul>
    <li>data-order-id: Ordernummer</li>
    <li>data-revenue: Total ordersumma</li>
    <li>data-tax: Total moms</li>
    <li>data-shipping: Frakt utan moms</li>
  </ul>
</div>
